jQuery(function($){
    initAddressApi('billing_postcode', 'billing_huisnummer', 'billing_toevoeging', 'billing_address_1', 'billing_city', $('.woocommerce-billing-fields__field-wrapper'));
    initAddressApi('shipping_postcode', 'shipping_huisnummer', 'shipping_toevoeging', 'shipping_address_1', 'shipping_city',  $('.woocommerce-shipping-fields__field-wrapper'));
});

export function initAddressApi(postcode, huisnummer, toevoeging, adres, city, $form){
    let postcodeInput = $form.find('input[name=' + postcode + ']');
    let huisnummerInput = $form.find('input[name=' + huisnummer + ']');
    let toevoegingInput = $form.find('input[name=' + toevoeging + ']');

    postcodeInput.on('input', detectChange);
    huisnummerInput.on('input', detectChange);
    toevoegingInput.on('input', detectChange);

    function detectChange(){
        if (postcodeInput.val() && huisnummerInput.val()){
            getStreetAndCity(postcodeInput.val(), huisnummerInput.val(), toevoegingInput.val(), adres, city, $form);
        }
    }
}

function getStreetAndCity(postcode, huisnummer, toevoeging,  adres, city, $form){
    let url = "https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2/adressen?postcode=" + postcode + "&huisnummer=" + huisnummer;

    jQuery.ajax({
        url: url,
        headers: {"X-Api-Key": "l759f23ec1d6ad46a19db993c25ef1b523"},
        success: function(data){
            if (data._embedded){
                let straatnaam = data._embedded.adressen[0].korteNaam;
                let stad = data._embedded.adressen[0].woonplaatsNaam;

                $form.find('input[name=' + city + ']').val(stad);
                $form.find('input[name=' + adres + ']').val(straatnaam + ' ' + huisnummer + toevoeging);
                $form.find('input[name=' + adres + ']').addClass('enabled');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            else{
                $form.find('input[name=' + city + ']').val('');
                $form.find('input[name=' + adres + ']').removeClass('enabled');
                $form.find('input[name=' + adres + ']').val('');
                $form.find('input[name=' + adres + ']').attr('placeholder', 'Adres niet gevonden');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            
        }
    });
}
